import { useEffect, useState } from "react"


export const GUARD_NAME_MIN = 4;
export const GUARD_NAME_MAX = 20;
export const AFFAIR_DESCRIPTION_MIN = 5;
export const AFFAIR_DESCRIPTION_MAX = 2048;
export const AFFAIR_TITLE_MIN = 5;
export const AFFAIR_TITLE_MAX = 200;


export function useDebounce<T>(value: T, delay?: number): T {
	const [debouncedValue, setDebouncedValue] = useState<T>(value)

	useEffect(() => {
		const timer = setTimeout(() => setDebouncedValue(value), delay || 500)

		return () => {
			clearTimeout(timer)
		}
	}, [value, delay])

	return debouncedValue
}

//https://stackoverflow.com/questions/32553158/detect-click-outside-react-component
export function useOutsideAlerter(ref, cb) {
	useEffect(() => {
		/**
		 * Alert if clicked on outside of element
		 */
		function handleClickOutside(event) {
			if (ref.current && !ref.current.contains(event.target)) {
				cb();
			}
		}
		// Bind the event listener
		document.addEventListener("mousedown", handleClickOutside);
		return () => {
			// Unbind the event listener on clean up
			document.removeEventListener("mousedown", handleClickOutside);
		};
	}, [ref, cb]);
}



export function formatDateTime(dateOrString: Date | string) {
	if (typeof dateOrString === 'string')
		dateOrString = new Date(dateOrString);
	if (dateOrString && typeof dateOrString === 'object' && dateOrString['toLocaleString'])
		return dateOrString.toLocaleString("hu-HU");
	else 
		return 'N/A';
}